"use strict";
exports.__esModule = true;
var angular = require("angular");
console.log('🔍 DEBUG: terminology-service.ts - File loading started');
// Register the terminology service with the smartorg.r6 module
angular.module('smartorg.r6').service('terminologyService', [function () {
        console.log('🔍 DEBUG: terminology-service.ts - Service constructor called');
        var self = this;
        // Cache for storing the current terminology
        var currentTerminology = null;
        var isLoaded = false;
        /**
         * Get terminology based on server configuration
         * This method also caches the terminology for later use
         */
        this.getTerminologyFromConfig = function (serverConfig) {
            console.log('🔍 DEBUG: terminology-service.ts - Getting terminology from server config:', serverConfig);
            try {
                var productType = 'PNAV';
                // Determine product type from server config
                if (serverConfig.productType) {
                    productType = serverConfig.productType.toString().toUpperCase();
                }
                else if (serverConfig.isInav) {
                    productType = 'INAV';
                }
                else if (serverConfig.isCorteva) {
                    productType = 'XNAV';
                }
                console.log('🔍 DEBUG: terminology-service.ts - Product type determined:', productType);
                // Return appropriate terminology based on product type
                var terminology = void 0;
                if (productType === 'XNAV') {
                    terminology = {
                        Portfolio: 'Experiment',
                        portfolio: 'experiment',
                        aPortfolio: 'an experiment',
                        Portfolios: 'Experiments',
                        portfolios: 'experiments',
                        'Create Portfolio': 'Create Experiment',
                        'Import Portfolio': 'Import Experiment',
                        'Export Portfolio': 'Export Experiment',
                        'Archive Portfolio': 'Archive Experiment',
                        'Portfolio Name': 'Experiment Name',
                        'Portfolio Settings': 'Experiment Settings'
                    };
                }
                else {
                    // Default terminology for PNAV and INAV
                    terminology = this.getDefaultTerminology();
                }
                // Cache the terminology
                currentTerminology = terminology;
                isLoaded = true;
                console.log('🔍 DEBUG: terminology-service.ts - Terminology cached:', terminology);
                return terminology;
            }
            catch (error) {
                console.error('🔍 DEBUG: terminology-service.ts - Error determining terminology:', error);
                // Default terminology on error
                var defaultTerminology = this.getDefaultTerminology();
                currentTerminology = defaultTerminology;
                isLoaded = true;
                return defaultTerminology;
            }
        };
        /**
         * Get the current cached terminology
         * This is the method components should use to get terminology
         */
        this.getCurrentTerminology = function () {
            console.log('🔍 DEBUG: terminology-service.ts - Getting current terminology, isLoaded:', isLoaded);
            if (isLoaded && currentTerminology) {
                console.log('🔍 DEBUG: terminology-service.ts - Returning cached terminology:', currentTerminology);
                return currentTerminology;
            }
            else {
                console.log('🔍 DEBUG: terminology-service.ts - No cached terminology, returning default');
                return this.getDefaultTerminology();
            }
        };
        /**
         * Check if terminology has been loaded from server config
         */
        this.isTerminologyLoaded = function () {
            return isLoaded;
        };
        /**
         * Get terminology based on URL detection (fallback method)
         * This allows components to get dynamic terminology without server config
         */
        this.getTerminologyFromUrl = function () {
            console.log('🔍 DEBUG: terminology-service.ts - Getting terminology from URL detection');
            try {
                var hostname = window.location.hostname.toLowerCase();
                var productType = 'PNAV';
                if (hostname.includes('inav')) {
                    productType = 'INAV';
                }
                else if (hostname.includes('xnav') || hostname.includes('corteva')) {
                    productType = 'XNAV';
                }
                console.log('🔍 DEBUG: terminology-service.ts - Product type determined from URL:', productType);
                // Return appropriate terminology based on product type
                if (productType === 'XNAV') {
                    return {
                        Portfolio: 'Experiment',
                        portfolio: 'experiment',
                        aPortfolio: 'an experiment',
                        Portfolios: 'Experiments',
                        portfolios: 'experiments',
                        'Create Portfolio': 'Create Experiment',
                        'Import Portfolio': 'Import Experiment',
                        'Export Portfolio': 'Export Experiment',
                        'Archive Portfolio': 'Archive Experiment',
                        'Portfolio Name': 'Experiment Name',
                        'Portfolio Settings': 'Experiment Settings'
                    };
                }
                else {
                    // Default terminology for PNAV and INAV
                    return this.getDefaultTerminology();
                }
            }
            catch (error) {
                console.error('🔍 DEBUG: terminology-service.ts - Error determining terminology from URL:', error);
                // Default terminology on error
                return this.getDefaultTerminology();
            }
        };
        /**
         * Get default terminology (PNAV/INAV style)
         * This can be used as fallback in components when terminology is not yet loaded
         */
        this.getDefaultTerminology = function () {
            return {
                Portfolio: 'Portfolio',
                portfolio: 'portfolio',
                aPortfolio: 'a portfolio',
                Portfolios: 'Portfolios',
                portfolios: 'portfolios',
                'Create Portfolio': 'Create Portfolio',
                'Import Portfolio': 'Import Portfolio',
                'Export Portfolio': 'Export Portfolio',
                'Archive Portfolio': 'Archive Portfolio',
                'Portfolio Name': 'Portfolio Name',
                'Portfolio Settings': 'Portfolio Settings'
            };
        };
        console.log('🔍 DEBUG: terminology-service.ts - Service initialized');
    }]);
console.log('🔍 DEBUG: terminology-service.ts - Module registration complete');
//# sourceMappingURL=terminology-service.js.map


// WEBPACK FOOTER //
// ./app/terminology-service.js